import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Button } from 'shared/ui/button'

import s from './styles.module.scss'

interface Props {
  isLoading?: boolean
  isPromoActive?: boolean
  discountText?: string
  isAvailable?: boolean
  onClick?: () => void
}

export const PromoButton = ({
  isLoading,
  discountText,
  isPromoActive,
  isAvailable = false,
  onClick,
}: Props) => {
  const { t } = useTranslation()

  const onClickHandler = () => {
    if (isLoading || isPromoActive) return

    onClick?.()
  }

  if (!isAvailable) return null

  return (
    <Button
      variant="grey"
      onClick={onClickHandler}
      className={clsx({ [s.buttonActive]: isPromoActive }, s.buttonWrapper)}
    >
      {isPromoActive ? (
        <div className={s.activePromoWrapper}>
          <AppIcon
            id={AllIcons.THUMBS_UP}
            className={s.icon}
          />
          <div className={s.discountWrapper}>
            <span className={clsx(s.promocode, 'semi-bold-16')}>
              {t('promocode_actived')}
            </span>

            {Boolean(discountText) && (
              <span className={clsx(s.promocode, 'regular-12')}>
                {discountText}
              </span>
            )}
          </div>
        </div>
      ) : (
        <span className={clsx(s.promocode, 'semi-bold-16')}>
          {t('have_promocode')}
        </span>
      )}
    </Button>
  )
}
